export function handleScroll() {
  return {
    scrolled: false,
    init() {
      window.addEventListener("scroll", () => {
        this.scrolled = window.scrollY > 3 * window.innerHeight;
      });
    },
  };
}
